import { Tooltip } from "@mui/material";
import React from "react";

interface IListStateIconProps {
  tooltip: string;
  icon: React.ElementType;
  color?: string;
  customColor?: string;
  noMargin?: boolean;
  rotation?: number;
  onClick?: () => void;
}

export const ListStateIcon = (props: IListStateIconProps) => {
    const Icon = props.icon;
    return (
        <Tooltip title={props.tooltip}>
            <Icon
                fontSize="small"
                color={props.customColor || props.color}
                sx={{ color: props.customColor, marginLeft: props.noMargin ? null : ".25rem", transform: props.rotation ? `rotate(${props.rotation}deg)` : undefined }}
                onClick={props.onClick}
            />
        </Tooltip>
    );
};
